import {Heading} from "@/components/typography/heading/Heading.tsx";
import {StatusPageLayoutPreset} from "@/lib/types/statuspages.ts";
import {isTwoColumnLayout} from "@/pages/statuspages/consumption/utils/layout.ts";
import classNames from "classnames";
import type {PublicStatusPageMetric} from "../../types.ts";
import {MetricCard} from "./components/MetricCard";
import styles from "./SystemMetrics.module.scss";

export interface SystemMetricsProps {
  metrics: PublicStatusPageMetric[];
  mode: "public" | "private";
  slug?: string;
  pageId?: number;
  timezone?: string;
  layout?: StatusPageLayoutPreset;
  variant?: "default" | "inspire";
}

export const SystemMetrics = ({
  metrics,
  mode,
  slug,
  pageId,
  timezone,
  layout = StatusPageLayoutPreset.EXPANDED,
  variant = "default",
}: SystemMetricsProps) => {
  if (metrics.length === 0) return null;

  const isTwoColumn = isTwoColumnLayout(layout);

  return (
    <div className={styles.systemMetrics}>
      <Heading as="h3" className={styles.sectionTitle}>
        System Metrics
      </Heading>
      <div className={classNames(styles.metricsContainer, {[styles.compact]: isTwoColumn})}>
        {metrics.map((metric) => (
          <MetricCard
            key={metric.id}
            metric={metric}
            mode={mode}
            slug={slug}
            pageId={pageId}
            timezone={timezone}
            variant={variant}
          />
        ))}
      </div>
    </div>
  );
};
